module.exports = __webpack_public_path__ + "installed-integration-hero-ee94ea14b7614d427c19d29fbe2b42ab.png";